import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "styled-components";

export const Loader = styled(CircularProgress)({
  margin: "0 10px 0 0",
});
